module.exports = __webpack_public_path__ + "img/1073350189.b95fc938.jpg";